import React from "react";
import InsightsNav from "../components/InsightsNav";
import styled from "styled-components";
const StyledInsights = styled.div`
  form {
    display: flex;
    flex-direction: column;
  }
`;
function Insights() {
  return (
    <StyledInsights>
      <InsightsNav keyword="RAGS" />
      Insights
    </StyledInsights>
  );
}

export default Insights;
